export const plusButtonWrapperStyle = { width: '100%', display: 'flex', justifyContent: 'flex-start' };
export const plusButtonStyle = { p: 0, '&:hover': { bgcolor: 'transparent' } };
export const plusButtonIconStyle = { color: 'rgba(145, 158, 171, 0.5)', mr: '0' };